<template>
  <div id="app">
    <template v-if="type == 'none'">
      <div class="">
        <router-view ref="routerRef" v-if="isRouterAlive"/>
      </div>
    </template>
    <template v-else-if="type == 'admin'">
      <router-view ref="routerRef" v-if="isRouterAlive"/>
    </template>
    <template v-else-if="type == 'doctor'">
      <headerDoctor ref="headerRef"></headerDoctor>
      <div class="contentIndex homeIndex">
        <router-view ref="routerRef" v-if="isRouterAlive"/>
        <footerCommon></footerCommon>
      </div>
    </template>
    <template v-else>
      <headerCommon ref="headerRef"></headerCommon>
      <div class="contentIndex homeIndex">
        <router-view ref="routerRef" v-if="isRouterAlive"/>
        <footerCommon></footerCommon>
      </div>
    </template>

  </div>
</template>

<script>
import base from '@/api/common'
import routerHandle from "@/api/router_handle";
import {mapMutations} from "vuex";

export default {
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      type: '',
      isRouterAlive: true,
      curAccount: '',
    }
  },
  watch: {
    '$route': 'handleRouteChange'
  },
  mounted() {

    // this.isRouterAlive = false
    this.curAccount = localStorage.getItem("account") || '';
    if (!localStorage.getItem('access_token')) {
      return;
    }
    // 后台页面不需要此请求
    let userType = localStorage.getItem('user_type');
    if(userType && userType == 3){
      return;
    }
    this.$ajax.post(base.api.communication.chat.unreadCount).then(res => {
      if (res.data.status === 'success') {
        this.setCommUnreadMsgCount(res.data.data);
      }
    });
    // 定时器

    let send_count = 0, fail_send_count = 0;
    let timer = setInterval(() => {
      if (send_count >= 540 || fail_send_count >= 3 || !localStorage.getItem('access_token')) { //超过3h未刷新网页 or 3次连续失败
        clearInterval(timer);
        return;
      }
      if (this.type == 'none') {
        return;
      }
      this.$ajax.post(base.api.communication.chat.unreadCount).then(res => {
        if (res.data.status === 'success') {
          this.setCommUnreadMsgCount(res.data.data);
        }
        send_count++;
        fail_send_count = 0;
      }).catch(() => {
        fail_send_count++;
      });
    }, 20000); // 20s 一次
  },
  methods: {
    ...mapMutations(['setCommUnreadMsgCount']),
    refreshNav() {
      this.$refs.headerRef.checkLoginStatus();
    },
    handleRouteChange: function () {
      // routerHandle.handleClientAdapter(this.$route,location);
      if (this.$route.path.startsWith('/doctor/')) {
        this.type = 'doctor'
      } else if (this.$route.path.startsWith('/admin/')) {
        this.type = 'admin';
        if (this.$route.path.indexOf('login') > 0) {
          this.type = 'none'; //admin login page
        }
      } else if (this.$route.path.startsWith('/chatClient') || this.$route.path.startsWith('/activeAccount')) {
        this.type = 'none'
      } else if (this.$route.name == 'doctorWorkbench' || this.$route.path.endsWith('/workbench/' + this.curAccount)) {
        if (localStorage.user_type && localStorage.user_type == 2) {
          this.type = 'doctor'
        }
      } else {
        this.type = ''
      }

      // 访问统计
      routerHandle.visitedStatistics(this.$route, location);
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
  },
  components: {
    'headerCommon': () => import('./components/headerCommon'),
    'headerDoctor': () => import('./components/headerDoctor'),
    'footerCommon': () => import('./components/footerCommon'),
  },
}
</script>

<style lang="scss">
#app {
  font-family: Microsoft YaHei UI;

}

.contentIndex {
  margin-top: 103px;
  height: calc(100vh - 103px);
  overflow-y: scroll;
}

.mt36 {
  margin-top: 36px;
}

</style>
